export const API_ENDPOINTS = {
  estimate: '/estimate',
  students: '/users/role/student/search',
  users: '/users/search',
  tags: '/tags',
  tagSearch: '/tags/tags/search',
};
